import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index-ua.scss';
import PatientApp from './Components/PatientApp/PatientApp';
import reportWebVitals from './reportWebVitals';
import StateMachine   from '../node_modules/react-simple-state/dist/';

import { Syncronizer as DomainResourceStoreSyncronizer } from './Documental/DomainResourceStore/Syncronizer.js';
import { DomainResourceStore } from './Documental/DomainResourceStore/DomainResourceStore.js';
import AuthToken  from './Documental/User/Authentication/AuthToken.js';
import AppAuthStatus  from './Documental/User/Authentication/AppAuthStatus.js';
import SessionCookie  from   './Documental/Utils/SessionCookie.js';
import WebSocketClient from './Documental/WebSocketClient';
import Logger from './Documental/Logger/Logger';
//import RenderListener from './Documental/EventListener/RenderListener';
import QuestionnaireListener from './Documental/EventListener/QuestionnaireListener';
import WebSocketListener from './Documental/EventListener/WebSocketListener';
import UrlHelper from './Documental/Utils/UrlHelper';
import QuestionnaireHolder  from './Documental/Questionnaire/QuestionnaireHolder';

console.log( "App version is " + process.env.REACT_APP_VERSION + " and build environment was " + process.env.NODE_ENV + " / CONFENV: " + process.env.REACT_APP_CONFIG_ENV );

window.dmDebug = {
  "skipQuestionnaire" : false
}

/*
  For testing @ localhost
  let xxx = new SessionCookie();
  xxx.createCookie( 'dmMode', 'self-assessment', 365 );
  //xxx.eraseCookie( 'dmSession' );
  //xxx.eraseCookie( 'app-auth-token' );
*/

// use external config if defined
if( typeof window.externalAppConfig !== 'undefined' ){
  console.log( 'App config is overwritten with external config' );
  console.log( window.externalAppConfig );
  if( typeof window.externalAppConfig.debugValue !== "undefined" ){
    let test = window.externalAppConfig.debugValue.split( ":" );
    console.log( test );
    for(var i in test ){
      if( test[ i ] === "skipq" ){
        window.dmDebug.skipQuestionnaire = true;
      }
    }

  }
}

let test22 = "aaaa";
console.log( test22.split("") );


window.debugNumber1 = Math.round( Math.random() * 100 );

const appState = new StateMachine();
appState.addListener( 'app-auth-status' );

window.appLoggedInUser = {
  "isLoggedIn" : false,
  "practitionerRoleId" : null
}

window.appLastGuidaneResesponse2 = {
  "hasRecievedGR" : false,
  "isWaiting" : false,
  "guidanceResponseId" : ""
}

var sessionCookie = new SessionCookie();
var authTokenCookie = sessionCookie.readCookieValue( 'app-auth-token' );
appState.evoke( 'app-auth-status', new AppAuthStatus( false, new AuthToken() ) );
if( authTokenCookie !== null && authTokenCookie && authTokenCookie != '' ){
  var authStatus = new AppAuthStatus( true, new AuthToken( authTokenCookie ) );
  appState.evoke( 'app-auth-status', authStatus ); 
}

appState.addListener( 'connection-state' );
appState.evoke( 'connection-state', { connected: false } );

appState.addListener( 'app-main-mode' );
appState.evoke( 'app-main-mode', {
  "appMainMode": "app-main-mode-default", // app-main-mode-default -> Estonian SR app
  "appMainModeLoaded": false,
  "featureFlags" : [{
    "featureKey" : "featureFlagDemo",
    "enabled" : true,
    "options" : {} 
  }]
} );

const EventEmitter = require('events');
window.appEventsEmitter = new EventEmitter();
window.appEventsEmitter.setMaxListeners( 10000 );

// currently global variable for testing
window.qHolder = new QuestionnaireHolder();

// setup event listeners
let socketListener = new WebSocketListener();
socketListener.startListening( window.appEventsEmitter );

let qListener = new QuestionnaireListener();
qListener.startListening( window.appEventsEmitter );

//let renderListener = new RenderListener();
//renderListener.startListening( window.appEventsEmitter );

// wrapper for storing entities in runtime
window.appEntityStore = new DomainResourceStore();
window.appEntityStore.startListening( window.appEventsEmitter );
window.appEntityStore.setSyncronizer( new DomainResourceStoreSyncronizer() );

let socketUrl = "wss://app.documental.ee/dm/wss";

if( typeof window.location.pathname !== "undefined" &&  typeof window.location.hostname !== "undefined" ){
  let portPart = '';
  if( typeof window.location.port !== "undefined" && window.location.port ){
    portPart = ":" + window.location.port;
  }
  socketUrl = 'wss://' + window.location.hostname + portPart + window.location.pathname;
  let lastChar = socketUrl.substr( socketUrl.length - 1);
  if( lastChar !== "/" ){
    socketUrl = socketUrl + "/";
  }
  socketUrl = socketUrl + "wss";
}

// process.env.REACT_APP_CONFIG_ENV
if( 
  process.env.NODE_ENV === "development"
){
  // Use command for local websocket: ssh -l root -L 8181:localhost:8181 app.documental.ee
  socketUrl = "ws://localhost:8181/dm/wss";
}

let urlParser = new UrlHelper();
let testingKey = urlParser.getQueryParam( "kkey", "" );

if( testingKey !== "" ){
  socketUrl = socketUrl + '?key=' + testingKey;
}


window.apiClient = new WebSocketClient();
window.apiClient.setEndpointUrl( socketUrl );
window.apiClient.init( window.appEventsEmitter );

// setup logger
window.appLogger = new Logger( window.apiClient );


ReactDOM.render(
  <PatientApp />,
  document.getElementById('root')
);


/* 
 prevent touch for safari so it wont swipe back in history 
 https://code-examples.net/en/q/1d37b82
 https://developer.apple.com/library/archive/documentation/AppleApplications/Reference/SafariWebContent/HandlingEvents/HandlingEvents.html 

var xPos = null;
var yPos = null;
window.addEventListener( "touchmove", function ( event ) {
  if( typeof event.originalEvent.touches !== 'undefined' ){

    var touch = event.originalEvent.touches[ 0 ];
    let oldX = xPos;
    let oldY = yPos;
    xPos = touch.pageX;
    yPos = touch.pageY;
    if ( oldX == null && oldY == null ) {
        return false;
    }
    else {
        if ( Math.abs( oldX-xPos ) > Math.abs( oldY-yPos ) ) {
            event.preventDefault();
            return false;
        }
    }
  }
} );

window.onbeforeunload = confirmFirst;

function confirmFirst() {   
  if(window.confirm("Leave the page?")){
    // some code
  }else{
   return false;
  } 
} 
*/


/**
 * Before leaving app page- ask user about leaving
 * 
 * This is used by chrome version 106.xx
 * Message can't be changed since Chrome 51. It is widely considered a security issue, and most vendors have removed support.

window.addEventListener( "beforeunload", function ( event ) {
  event.preventDefault();
  event.returnValue = "Are you sure you want to exit app 1?";
  return event;
} );
*/


/**
window.addEventListener( "onbeforeunload", function ( event ) {
  event.preventDefault();
  console.log( "beforeunload 112221" );
  console.log( event );
  return event.returnValue = "Are you sure you want to exit app 2?";
  return false;
} );
 */

/**
var isOnIOS = navigator.userAgent.match(/iPad/i)|| navigator.userAgent.match(/iPhone/i);

if( isOnIOS ){
  function addEventd(obj, evType, fn){
    if (obj.addEventListener){
      obj.addEventListener(evType, fn, true );
      return true;
    } else if (obj.attachEvent){
      var r = obj.attachEvent("on"+evType, fn);
      return r;
    } else {
      alert("Handler could not be attached");
    }
  }


  addEventd( window, "pagehide", function( event ){
    return event.returnValue = "Are you sure you want to exit app 33?";
  } );

  addEventd( window, "beforeunload", function( event ){
    return event.returnValue = "Are you sure you want to exit app 22?";
  } );

  window.addEventListener( "pagehide", function (event) { 
      window.event.cancelBubble = true; // Don't know if this works on iOS but it might!
      
  } );
}

window.addEventListener('pagehide', function (event) {
  if (event.persisted) {
    // If the event's persisted property is `true` the page is about
    // to enter the Back-Forward Cache, which is also in the frozen state
    alert( " TEST: pagehide event.persisted");
  } else {
    // If the event's persisted property is not `true` the page is about to be unloaded.
    alert( " TEST: pagehide pagehide triggered");
  }
  
}, true);

*/

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
